import React, { Fragment, useEffect } from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import './App.css';
import Navbar from './components/layout/Navbar'
import Landing from './components/layout/Landing'
import Register from './components/auth/Register'
import Login from './components/auth/Login'
import Alert from './components/layout/Alert'
import Dashboard from './components/dashboard/dashboard'
import PrivateRoute from './components/routing/PrivateRoute'
import CreateProfile from './components/profile-form/createProfile'
import EditProfile from './components/profile-form/editProfile'
import AddExperience from './components/profile-form/addExperience'
import AddEducation from './components/profile-form/addEducation'
import Profiles from './components/profiles/Profiles'
import Posts from './components/post/post'
import Profile from './components/profile/Profile'
// redux
import {Provider} from 'react-redux'
import store from './store'
import setAuthToken from './utils/setAuthToken'
import {loadUser} from './action/auth'

if(localStorage.token){
   setAuthToken(localStorage.token)
}

const App = () =>{
  useEffect(() => {
    store.dispatch(loadUser())
  },[])
  return(
<Provider store={store}>
  <Router>
  <Fragment>
      <Navbar/>
      <Route exact path='/' component={Landing} />
      <section className="container">
       <Alert />
        <Switch>
          <Route exact path = "/register" component={Register}/>
          <Route exact path = "/login" component={Login}/>
          <Route exact path = "/profiles" component={Profiles}/>
          <Route exact path = "/profile/:id" component={Profile}/>
          <PrivateRoute exact path = "/dashboard" component={Dashboard}/>
          <PrivateRoute exact path = "/posts" component={Posts}/>
          <PrivateRoute exact path = "/create-profile" component={CreateProfile}/>
          <PrivateRoute exact path = "/edit-profile" component={EditProfile}/>
          <PrivateRoute exact path = "/add-experience" component={AddExperience}/>
          <PrivateRoute exact path = "/add-education" component={AddEducation}/>

        </Switch>
      </section>
  </Fragment>
  </Router>
</Provider>
  )}  

export default App;
